import { Routes } from '@angular/router';

export const agentsRoutes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./components/agent-list/agent-list.component').then(
        (m) => m.AgentListComponent
      ),
  },
  {
    path: ':apiKeyId',
    loadComponent: () =>
      import('./components/agent-detail/agent-detail.component').then(
        (m) => m.AgentDetailComponent
      ),
    data: { breadcrumb: 'Agent' },
  },
];
